import { render, staticRenderFns } from "./sassPlatform.vue?vue&type=template&id=2fc11b4c&scoped=true&"
import script from "./sassPlatform.vue?vue&type=script&lang=js&"
export * from "./sassPlatform.vue?vue&type=script&lang=js&"
import style0 from "./sassPlatform.vue?vue&type=style&index=0&id=2fc11b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc11b4c",
  null
  
)

export default component.exports